import { number, money, date } from "./purchase-order-presentation";
import type { PurchaseOrdersViewState } from "./purchase-order-view-state";

type Props = {} & { dialog: Extract<NonNullable<PurchaseOrdersViewState["dialog"]>, { kind: "create"; }>; };

export function PurchaseOrderCreateFields({ dialog }: Props) {
  return (<>
    <>
      <div className="purchase-order-decision">
        <span>{dialog.candidate.requestNo}</span>
        <strong>{dialog.candidate.requestTitle}</strong>
        <p>
          {dialog.candidate.supplierName} · {dialog.candidate.offerNo}
        </p>
      </div>
      <dl>
        <div>
          <dt>Miktar</dt>
          <dd>
            {number(dialog.candidate.quantity)}{" "}
            {dialog.candidate.unit}
          </dd>
        </div>
        <div>
          <dt>Birim fiyat</dt>
          <dd>
            {money(
              dialog.candidate.unitPrice,
              dialog.candidate.currency,
            )}
          </dd>
        </div>
        <div>
          <dt>Ana mal bedeli</dt>
          <dd>
            {money(
              dialog.candidate.materialAmount,
              dialog.candidate.currency,
            )}
          </dd>
        </div>
        <div>
          <dt>Nakliye</dt>
          <dd>
            {money(
              dialog.candidate.shippingCost,
              dialog.candidate.currency,
            )}
          </dd>
        </div>
        <div>
          <dt>Sigorta</dt>
          <dd>
            {money(
              dialog.candidate.insuranceCost,
              dialog.candidate.currency,
            )}
          </dd>
        </div>
        <div>
          <dt>Kurulum</dt>
          <dd>
            {money(
              dialog.candidate.installationCost,
              dialog.candidate.currency,
            )}
          </dd>
        </div>
        <div>
          <dt>Diğer maliyet</dt>
          <dd>
            {money(
              dialog.candidate.otherCost,
              dialog.candidate.currency,
            )}
          </dd>
        </div>
        <div>
          <dt>Nihai sipariş toplamı</dt>
          <dd>
            {money(
              dialog.candidate.amount,
              dialog.candidate.currency,
            )}
          </dd>
        </div>
        <div>
          <dt>Ödeme vadesi</dt>
          <dd>{dialog.candidate.paymentDays} gün</dd>
        </div>
        <div>
          <dt>Teslim süresi</dt>
          <dd>{dialog.candidate.deliveryDays} gün</dd>
        </div>
        <div>
          <dt>İhtiyaç tarihi</dt>
          <dd>{date(dialog.candidate.neededAt)}</dd>
        </div>
        <div>
          <dt>Hesaplanan teslim tarihi</dt>
          <dd>{date(dialog.candidate.expectedDeliveryAt)}</dd>
        </div>
        <div>
          <dt>Nihai karar</dt>
          <dd>
            {dialog.candidate.decidedBy} ·{" "}
            {date(dialog.candidate.decidedAt)}
          </dd>
        </div>
        <div>
          <dt>Sürümler</dt>
          <dd>
            Talep {dialog.candidate.requestVersion} · Teklif{" "}
            {dialog.candidate.offerVersion} · Değerlendirme{" "}
            {dialog.candidate.evaluationVersion}
          </dd>
        </div>
      </dl>
      <p className="purchase-order-next-step-note">
        Siparişi oluşturduğunuzda kayıt taslak olarak Siparişler
        bölümüne taşınacaktır. Sipariş henüz tedarikçiye
        gönderilmeyecektir.
      </p>
    </>
  </>);
}
